import BorderOuterOutlinedIcon from '@mui/icons-material/BorderOuterOutlined';
import AspectRatioOutlinedIcon from '@mui/icons-material/AspectRatioOutlined';

export const codeToicons = {
    'f851': <BorderOuterOutlinedIcon fontSize="large" />,
    'e495': <AspectRatioOutlinedIcon fontSize="large" />,
}